import React from 'react'
import { Radio, Select, Form, Popover } from 'antd'
import IconTooltip from './IconTooltip'
import AppStore from "../../Configs/Store/index"
import Dropdown_Icon from "../../assets/Dropdown_Icon.svg"
import Icon from '@ant-design/icons'
import Image from "../Common/Image"


const DropdownIcon = () => (
  <Image src={Dropdown_Icon} alt={'Dropdown'} style={{ marginLeft: -10 }} width={AppStore.device===1 ? "10px" : "20px"} height={AppStore.device===1 ? "12px" : "11px"} />
)

const RadioGroup = ({ className, formClass, jsonData, dynamicTitle, propValue, hideValue, ddClassName = "ddDropdown", overlayClassName, colon, onChange, onToolTipClick, type, infoIcon, condition, extraCon, disableQ, reverse, highestToggle, styleName, formName, validate, validateMesssage, ...props }) => {
  // console.info("Condtion :", ddClassName)

  var disabledQFlag = false

  if (condition === undefined)
    condition = ""

  if (hideValue === undefined)
    hideValue = []

  if (disableQ !== undefined) {
    disabledQFlag = disableQ
  }

  const containsData = (array, value) => {
    // console.info("ARRAY :", array)
    if (array === undefined) return false
    else return array.includes(value)
  }

  const findParentContainer = () => {
    var element
    try {
      element = document.querySelector(`.${ddClassName}`)
      if (element !== null)
        return element
      else
        return document.body
    } catch {
      return document.body
    }
  }

  return (
    <Form.Item
      name={formName} colon={colon} className={formClass}
      rules={[{ required: validate, message: validateMesssage }]}
      label={
        <>
          {infoIcon ?
            <div className={className}>{dynamicTitle === "" ? jsonData['title'] : dynamicTitle} <IconTooltip title={jsonData['tooltip']} onClick={onToolTipClick} zIndex={AppStore.device === 0 ? -1 : null} /></div>
            :
            <div className={className}>{dynamicTitle === "" ? jsonData['title'] : dynamicTitle}</div>
          }
        </>
      }
    >
      {type === 0 ?
        <Select
          className={AppStore.device === 0 ? "" : "width180"}
          options={jsonData['options']} defaultValue={propValue} dropdownClassName={overlayClassName}
          onChange={onChange} getPopupContainer={findParentContainer}
          suffixIcon={<Icon component={DropdownIcon} className="ant-select-suffix" />}
          {...props}
        />
        :
        <Radio.Group
          // options={jsonData['options']}
          optionType="button"
          onChange={onChange}
          defaultValue={propValue}
          {...props}
        // className={'marginBottom10'}
        >
          {Object.entries(jsonData['options']).filter(([fi, fv], fI) => !hideValue.includes(fv['value'])).map(([i, v], index) =>
            <span key={"RadioGrp_" + new Date().getTime() + "_" + v.value}>
              <Radio.Button value={v.value} style={AppStore.device === 0 ? styles[0][styleName] : styles[1][styleName]}
                disabled={disabledQFlag ? disableQ : (condition === "" ? false : reverse ? condition === v.value : condition !== v.value) || containsData(extraCon, v.value)}>{v.label}
              </Radio.Button>
            </span>
          )}
        </Radio.Group>

      }
    </Form.Item>
  )
}

const styles = {
  1: {
    radioGender: {
      maxWidth: 115,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    radioBuyFor: {
      maxWidth: 90,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    radioHowPlan: {
      maxWidth: 100,
      width: '100%',
      height: 32,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    radioProcced: {
      maxWidth: 80,
      width: '100%',
      height: 32,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    radioQuoteGroup: {
      width: '100%',
      height: 32,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
    }
  },
  0: {
    radioGender: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    radioBuyFor: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    radioAnnualIncome: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: 0,
    },
    radioHowPlan: {
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    radioProcced: {
      height: 36,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    radioQuoteGroup: {
      width: '100%',
      height: 32,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
    }
  }
}

export default RadioGroup